export default {"src":"/_next/static/media/towtruck-icon.fb2ecba1.svg","height":42,"width":43};